import {AfterViewChecked, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {State} from '@core/services/state';
import {CountryService} from '@core/services/country.service';
import {AppLeague} from '@shared/models/league';
import {LeagueService} from '@core/services/league.service';
import {StateService} from '@core/services/state.service';
// import {SwiperComponent, SwiperConfigInterface} from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-search-start',
  templateUrl: './search-start.component.html',
  styleUrls: ['./search-start.component.scss']
})
export class SearchStartComponent implements OnInit, AfterViewChecked {
  @Input() onMobileView: boolean = false;
  @Output() stateSelected = new EventEmitter<string>();

  /*@ViewChild('statesSlider', {static: true}) statesSlider;
  @ViewChild('leaguesSlider', {static: true}) leaguesSlider;*/

  states: State[] = [];
  topLeagues: AppLeague[] = [];

  /*public config: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    slidesPerView: 6,
    slidesPerGroup: 2,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: false,
  };*/

  public stateNextButtonHidden = true;
  public statePrevButtonHidden = true;

  public leagueNextButtonHidden = true;
  public leaguePrevButtonHidden = true;


  constructor(
    private leagueService: LeagueService,
    private countryService: CountryService,
  ) {
  }

  ngOnInit() {
    this.countryService.fetchStatesOfCountry(CountryService.austrianId)
      .then((states: State[]) => {
        for (const state of states) {
          this.states.push(state);
        }

        /*if (this.statesSlider) {
          this.statesSlider.directiveRef.update();
          if (this.states.length > this.config.slidesPerView) {
            this.stateNextButtonHidden = false;
          }
        }*/
      })
      .catch(function() {
        console.log('statesPromise: Something went wrong.')
      });

    this.fetchMaleTopLeagues();
    this.fetchFemaleTopLeagues();
    this.fetchYouthTopLeagues();
  }

  ngAfterViewChecked(): void {
    /*if (this.statesSlider == null || this.leaguesSlider == null) {
      return;
    }

    this.statesSlider.directiveRef.indexChange.subscribe(index => {
      this.stateSliderIndexChanged(index);
    });

    this.leaguesSlider.directiveRef.indexChange.subscribe(index => {
      this.leagueSliderIndexChanged(index);
    });*/
  }

  private fetchMaleTopLeagues() {
    this.leagueService.fetchTopLeagues(CountryService.austrianId, 'male').then(topLeagues => {
      topLeagues.forEach(async topLeague => {
        await this.addSubLeaguesToTopLeagues(topLeague);
      });
    });
  }

  private fetchFemaleTopLeagues() {
    this.leagueService.fetchTopLeagues(CountryService.austrianId, 'female').then(topLeagues => {
      topLeagues.forEach(async topLeague => {
        await this.addSubLeaguesToTopLeagues(topLeague);
      });
    });
  }

  private fetchYouthTopLeagues() {
    this.leagueService.fetchTopLeagues(CountryService.austrianId, 'youth').then(topLeagues => {
      topLeagues.forEach(async topLeague => {
        await this.addSubLeaguesToTopLeagues(topLeague);
      });
    });
  }

  private async addSubLeaguesToTopLeagues(topLeague: AppLeague) {
    if (topLeague.has_subleagues === true) {
      await this.leagueService.fetchStructuredSubLeaguesOfLeague(topLeague.id).then(subLeagues => {
        subLeagues.forEach(subLeague => {
          this.topLeagues = this.topLeagues.concat(subLeague.league);
        });
      });
    } else {
      this.topLeagues.push(topLeague);
    }
    /*if (this.leaguesSlider) {
      this.leaguesSlider.directiveRef.update();
      if (this.config.slidesPerView < this.topLeagues.length) {
        this.leagueNextButtonHidden = false;
      }
    }*/
  }

  public onStateClick(state: State) {
    this.stateSelected.emit(state.id);
  }

  /*public prevState() {
    this.statesSlider.directiveRef.prevSlide();
  }

  public nextState() {
    this.statesSlider.directiveRef.nextSlide();
  }

  public prevLeague() {
    this.leaguesSlider.directiveRef.prevSlide();
  }

  public nextLeague() {
    this.leaguesSlider.directiveRef.nextSlide();
  }*/

  private stateSliderIndexChanged(index) {
    /*const slidesPerView = this.config.slidesPerView as number;

    if (index === 0) {
      this.statePrevButtonHidden = true;
    } else if (this.states.length > slidesPerView) {
      this.statePrevButtonHidden = false;
    }

    if (index === (this.states.length - slidesPerView)) {
      this.stateNextButtonHidden = true;
    } else if (this.states.length > slidesPerView) {
      this.stateNextButtonHidden = false;
    }*/
  }

  private leagueSliderIndexChanged(index) {
    /*const slidesPerView = this.config.slidesPerView as number;

    if (index === 0) {
      this.leaguePrevButtonHidden = true;
    } else if (this.topLeagues.length > slidesPerView) {
      this.leaguePrevButtonHidden = false;
    }

    if (index === (this.topLeagues.length - slidesPerView)) {
      this.leagueNextButtonHidden = true;
    } else if (this.topLeagues.length > slidesPerView) {
      this.leagueNextButtonHidden = false;
    }*/
  }

  isSSRServer(): boolean {
    return !StateService.isBrowser;
  }
}
